// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteQuestion,
//   fetchClassesList,
//   fetchQuestions,
//   fetchQuestionTypes,
//   getChapters,
//   getSubjects,
//   setState,
// } from "./redux/questionBankSlice";
// import DeleteIcon from "@mui/icons-material/Delete";
// import ModeEditIcon from "@mui/icons-material/ModeEdit";
// import { Button, Dialog, DialogTitle, Tooltip } from "@mui/material";
// import AddQuestionForm from "./AddNewQuestion";
// import { ModeEdit } from "@mui/icons-material";
// import CloseIcon from "@mui/icons-material/Close";
// function QuestionBank() {
//   const dispatch = useDispatch();
//   const {
//     classList,
//     selectedClassId,
//     subjects,
//     selectedSubjectId,
//     chapters,
//     selectedChapterId,
//     questionTypes,
//     selectedQuestionTypeId,
//     addNewQuestion,
//     questions,
//     status,
//     viewQuestion,
//     specificQuestion,
//     addFile,
//     error,
//   } = useSelector((state) => state.questionBank);
//   const { user } = useSelector((store) => store.authSlice);
//   const user_id = user.user.id;
//   useEffect(() => {
//     dispatch(fetchClassesList());
//     dispatch(fetchQuestionTypes());
//   }, [dispatch]);
//   useEffect(() => {
//     dispatch(getSubjects(selectedClassId));
//   }, [selectedClassId]);
//   useEffect(() => {
//     if (selectedClassId && selectedSubjectId) {
//       dispatch(getChapters({ selectedClassId, selectedSubjectId }));
//     }
//   }, [selectedClassId, selectedSubjectId, dispatch]);
//   useEffect(() => {
//     if (selectedClassId && selectedSubjectId && selectedChapterId) {
//       dispatch(
//         fetchQuestions({
//           selectedClassId,
//           selectedSubjectId,
//           selectedChapterId,
//           user_id,
//         })
//       );
//     }
//   }, [selectedClassId, selectedSubjectId, selectedChapterId, dispatch]);

//   if (status === "loading") return <p>Loading classes...</p>;
//   if (status === "failed") return <p>Error: {error}</p>;
//   console.log("specificQuestion", specificQuestion);
//   const handleDeleteQuestion = (id) => {
//     if (
//       !window.confirm(
//         "Are you sure you want to delete this question? This action cannot be undone."
//       )
//     ) {
//       return;
//     }

//     dispatch(
//       deleteQuestion({
//         id,
//         classId: selectedClassId,
//         subjectId: selectedSubjectId,
//         chapterId: selectedChapterId,
//         questionTypeId: selectedQuestionTypeId,
//       })
//     );
//   };
//   const excludedKeys = [
//     "created_by",
//     "updated_by",
//     "link_id",
//     "passage_text",
//     "image_exist_status",
//     "subject_id",
//     "class_id",
//     "chapter_id",
//     "question_typeid",
//     "difficulty_id",
//     "options",
//     "images",
//     "matching_options",
//   ];
//   const renamedKeys = {
//     question_id: "ID",
//     question_text: "Question",
//     type_name: "Type",
//     difficulty_name: "Difficulty",
//     class_name: "Class",
//     subject_name: "Subject",
//     chapter_name: "Chapter",
//   };

//   const displayEntries = Object.entries(specificQuestion).filter(
//     ([key]) => !excludedKeys.includes(key)
//   );

//   return (
//     <div>
//       <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
//         Question Bank
//       </h3>
//       <div className="bg-white  mb-8 max-w-4xl mx-auto">
//         <div className="grid grid-cols-1 py-4 ps-3 shadow rounded-3  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
//           {/* Filter 1: Class */}
//           <div className="row w-100">
//             <div className="col-md-6 ">
//               <div className="row mb-2">
//                 <label
//                   htmlFor="class-select"
//                   className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
//                 >
//                   Select Class:
//                 </label>
//                 <div className="col-sm-8">
//                   <select
//                     id="class-select"
//                     value={selectedClassId || ""}
//                     onChange={(e) => {
//                       dispatch(
//                         setState({
//                           key: "selectedClassId",
//                           value: Number(e.target.value),
//                         })
//                       );
//                       dispatch(getSubjects(e.target.value));
//                     }}
//                     className="w-full p-2 form-control border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     // disabled={isLoading}
//                   >
//                     <option value="">-- Select Class --</option>
//                     {classList.length === 0 ? (
//                       <option disabled>No classes available</option>
//                     ) : (
//                       classList.map((cls) => (
//                         <option
//                           key={cls.class_id}
//                           value={cls.class_id.toString()}
//                         >
//                           {cls.class_name}
//                         </option>
//                       ))
//                     )}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 ">
//               <div className="row mb-2">
//                 <label
//                   htmlFor="subject-select"
//                   className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
//                 >
//                   Select Subject:
//                 </label>
//                 <div className="col-sm-8">
//                   <select
//                     id="subject-select"
//                     value={selectedSubjectId}
//                     onChange={(e) => {
//                       dispatch(
//                         setState({
//                           key: "selectedSubjectId",
//                           value: Number(e.target.value),
//                         })
//                       );
//                     }}
//                     className="w-full form-control p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     disabled={!selectedClassId || subjects.length === 0}
//                   >
//                     <option value="">-- Select Subject --</option>
//                     {subjects.length === 0 && selectedClassId ? (
//                       <option disabled>No subjects for this class</option>
//                     ) : (
//                       subjects.map((sub) => (
//                         <option
//                           key={sub.subject_id}
//                           value={sub.subject_id.toString()}
//                         >
//                           {sub.subject_name}
//                         </option>
//                       ))
//                     )}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 ">
//               <div className="row mb-2">
//                 <label
//                   htmlFor="chapter-select"
//                   className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
//                 >
//                   Select Chapter:
//                 </label>
//                 <div className="col-sm-8">
//                   <select
//                     id="chapter-select"
//                     value={selectedChapterId}
//                     onChange={(e) => {
//                       dispatch(
//                         setState({
//                           key: "selectedChapterId",
//                           value: Number(e.target.value),
//                         })
//                       );
//                     }}
//                     className="w-full p-2 form-control border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     disabled={
//                       !selectedSubjectId ||
//                       !selectedClassId ||
//                       chapters.length === 0
//                     }
//                   >
//                     <option value="">-- Select Chapter --</option>
//                     {chapters.length === 0 &&
//                     selectedSubjectId &&
//                     selectedClassId ? (
//                       <option disabled>No chapters for this subject</option>
//                     ) : (
//                       chapters.map((chap) => (
//                         <option
//                           key={chap.chapter_id}
//                           value={chap.chapter_id.toString()}
//                         >
//                           {chap.chapter_name}
//                         </option>
//                       ))
//                     )}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 ">
//               <div className="row mb-2">
//                 <label
//                   htmlFor="question-type-select"
//                   className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
//                 >
//                   Select Question Type:
//                 </label>
//                 <div className="col-sm-8">
//                   <select
//                     id="question-type-select"
//                     value={selectedQuestionTypeId}
//                     onChange={(e) => {
//                       dispatch(
//                         setState({
//                           key: "selectedQuestionTypeId",
//                           value: Number(e.target.value),
//                         })
//                       );
//                     }}
//                     className="w-full form-control p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     disabled={questionTypes.length === 0}
//                   >
//                     <option value="">-- All Types --</option>
//                     {questionTypes.length === 0 ? (
//                       <option disabled>No types available</option>
//                     ) : (
//                       questionTypes.map((type) => (
//                         <option key={type.type_id} value={type.type_id}>
//                           {type.type_id}--- {type.type_name}
//                         </option>
//                       ))
//                     )}
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Button variant="contained" className="w-full">
//             Upload Questions
//           </Button>
//           <Button
//             variant={"contained"}
//             className="w-full"
//             style={{ marginLeft: "2%" }}
//             onClick={() => {
//               dispatch(setState({ key: "addNewQuestion", value: true }));
//             }}
//             disabled={
//               !selectedClassId ||
//               !selectedSubjectId ||
//               !selectedChapterId ||
//               !selectedQuestionTypeId
//             }
//           >
//             Add New Question
//           </Button>
//         </div>
//         <hr className="my-8 border-gray-300" />
//         {questions.length > 0 && !addNewQuestion && (
//           <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
//             <div className="table-responsive p-2 rounded-3">
//               <table className="table  table-striped table-bordered text-15">
//                 <tdbody>
//                   <tr className="bg-gray-200 text-gray-700">
//                     <th className="text-center">ID</th>
//                     <th className="text-center">Question </th>
//                     <th className="text-center">Type</th>
//                     <th className="text-center">Class</th>
//                     <th className="text-center">Subject</th>
//                     <th className="text-center">Chapter</th>
//                     <th className="text-center">Upload</th>
//                     <th className="text-center">Difficulty</th>
//                     <th className="text-center" style={{ minWidth: "110px" }}>
//                       Actions
//                     </th>
//                   </tr>
//                   {questions.map((q) => (
//                     <tr key={q.question_id} className="hover:bg-gray-100">
//                       <td className="text-center">
//                         <span key={q.question_id}> {q.question_id}</span>
//                       </td>
//                       <td className="text-wrap">
//                         {q.question_typeid === 6
//                           ? q.passage_text
//                           : q.question_text}
//                       </td>
//                       <td className="text-center">{q.type_name}</td>
//                       <td className="text-center">{q.class_name}</td>
//                       <td className="text-center">{q.subject_name}</td>
//                       <td className="text-center">{q.chapter_name}</td>
//                       <td className="text-center">
//                         {q.question_typeid === 16 ? ( //16 is for matching
//                           <button

//                           //   setSelectedMatchData(q); // q is the full question object
//                           //   setShowMatchModal(true);
//                           // }}
//                           >
//                             View More
//                           </button>
//                         ) : (
//                           <>
//                             <Button
//                               variant="contained"
//                               onClick={() => {
//                                 dispatch(
//                                   setState({
//                                     key: "addFile",
//                                     value: true,
//                                   })
//                                 );
//                                 dispatch(
//                                   setState({
//                                     key: "specificQuestion",
//                                     value: q,
//                                   })
//                                 );
//                               }}
//                             >
//                               Add
//                             </Button>
//                             <Button
//                               variant="contained"
//                               onClick={() => {
//                                 dispatch(
//                                   setState({
//                                     key: "viewQuestion",
//                                     value: true,
//                                   })
//                                 );
//                                 dispatch(
//                                   setState({
//                                     key: "specificQuestion",
//                                     value: q,
//                                   })
//                                 );
//                               }}
//                             >
//                               View
//                               {/* // onClick={() => handleViewClick(q)}> View */}
//                             </Button>
//                           </>
//                         )}
//                       </td>

//                       <td className="text-center">{q.difficulty_name}</td>
//                       <td className="text-center">
//                         <div className="flex justify-center space-x-2">
//                           <button
//                             onClick={() => handleDeleteQuestion(q.question_id)}
//                             // disabled={isLoading}
//                             className="bg-red-500 btn btn-sm btn-outline-danger   hover:bg-red-600 transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
//                           >
//                             <DeleteIcon />
//                             {/* <i className="bi bi-trash"></i> */}
//                           </button>
//                           <button
//                             // onClick={() => handleEditQuestion(q)}
//                             // disabled={isLoading}
//                             style={{ marginLeft: "2%" }}
//                             className="   btn btn-sm btn-outline-primary    transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
//                           >
//                             <ModeEditIcon />
//                             {/* <i className="bi bi-pencil-square"></i> */}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tdbody>
//               </table>
//             </div>
//             <Dialog
//               onClose={() =>
//                 dispatch(
//                   setState({
//                     key: "viewQuestion",
//                     value: false,
//                   })
//                 )
//               }
//               PaperProps={{
//                 style: {
//                   width: "80vw", // 80% of viewport width
//                   maxWidth: "none", // allow full custom width
//                   height: "40vh", // 80% of viewport height
//                 },
//               }}
//               open={viewQuestion}
//             >
//               <CloseIcon
//                 style={{ cursor: "pointer", marginLeft: "95%" }}
//                 onClick={() =>
//                   dispatch(
//                     setState({
//                       key: "viewQuestion",
//                       value: false,
//                     })
//                   )
//                 }
//               />

//               <DialogTitle>Variants</DialogTitle>
//               <table
//                 className="table table-bordered"
//                 style={{ width: "90%", marginLeft: "2%" }}
//               >
//                 <thead>
//                   <tr>
//                     {displayEntries.map(([key], index) => (
//                       <th key={index}>{renamedKeys[key] || key} </th>
//                     ))}
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     {displayEntries.map(([_, value], index) => (
//                       <td key={index}>
//                         {typeof value === "object" && value !== null
//                           ? JSON.stringify(value)
//                           : value?.toString() || "-"}
//                       </td>
//                     ))}
//                     <td>
//                       <Tooltip title="Delete Question">
//                         <DeleteIcon
//                           style={{ cursor: "pointer", color: "red" }}
//                         />{" "}
//                       </Tooltip>
//                       <Tooltip title="Edit Question">
//                         <ModeEdit
//                           style={{ cursor: "pointer", color: "blue" }}
//                         />
//                       </Tooltip>
//                     </td>{" "}
//                   </tr>
//                 </tbody>
//               </table>
//             </Dialog>
//             <Dialog
//               onClose={() =>
//                 dispatch(
//                   setState({
//                     key: "addFile",
//                     value: false,
//                   })
//                 )
//               }
//               PaperProps={{
//                 style: {
//                   width: "80vw", // 80% of viewport width
//                   maxWidth: "none", // allow full custom width
//                   height: "40vh", // 80% of viewport height
//                 },
//               }}
//               open={addFile}
//             >
//               <CloseIcon
//                 style={{ cursor: "pointer", marginLeft: "95%" }}
//                 onClick={() =>
//                   dispatch(
//                     setState({
//                       key: "addFile",
//                       value: false,
//                     })
//                   )
//                 }
//               />

//               <DialogTitle>Upload Question File </DialogTitle>
//               <input type="file" style={{ marginLeft: "2%" }} />
//             </Dialog>
//             {/* <div>
//               {addVariantModal && (
//                 <div
//                   style={{
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: "rgba(0,0,0,0.5)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     zIndex: 1000,
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "#fff",
//                       padding: "20px",
//                       width: "90%",
//                       maxWidth: "1200px",
//                       maxHeight: "90vh",
//                       overflowY: "auto",
//                       borderRadius: "8px",
//                       position: "relative",
//                     }}
//                   >
//                     <button
//                       onClick={() => closeAddVariantModal()}
//                       style={{
//                         position: "absolute",
//                         top: "10px",
//                         right: "15px",
//                         fontSize: "18px",
//                         background: "transparent",
//                         border: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       ❌
//                     </button>
//                     <h2>Upload Question File</h2>
//                     <input
//                       type="file"
//                       accept=".json,.xlsx"
//                       onChange={handleFileUpload}
//                     />

//                     {uploadedData?.questions?.length > 0 && (
//                       <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative mt-4">
//                         <div className="table-responsive p-2 rounded-3">
//                           <table className="table table-striped table-bordered text-15 w-full">
//                             <thead>
//                               <tr className="bg-gray-200 text-gray-700">
//                                 <th className="text-center">#</th>
//                                 <th className="text-center">Question</th>
//                                 <th className="text-center">Options</th>
//                                 <th className="text-center">Type ID</th>
//                                 <th className="text-center">Class ID</th>
//                                 <th className="text-center">Subject ID</th>
//                                 <th className="text-center">Chapter ID</th>
//                                 <th className="text-center">Difficulty ID</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {uploadedData.questions.map((q, index) => (
//                                 <tr
//                                   key={q.id || index}
//                                   className="hover:bg-gray-100"
//                                 >
//                                   <td className="text-center">{index + 1}</td>
//                                   <td className="text-wrap">
//                                     {q.question_text}
//                                   </td>
//                                   <td className="text-wrap max-w-xs min-w-[150px] break-words">
//                                     <ol type="A" className="pl-4 list-decimal">
//                                       {Array.isArray(q.options) &&
//                                         q.options.map((opt, i) => (
//                                           <li key={i}>{opt.text}</li>
//                                         ))}
//                                     </ol>
//                                   </td>
//                                   <td className="text-center">
//                                     {q.question_typeid}
//                                   </td>
//                                   <td className="text-center">
//                                     {uploadedData.class_id}
//                                   </td>
//                                   <td className="text-center">
//                                     {uploadedData.subject_id}
//                                   </td>
//                                   <td className="text-center">
//                                     {uploadedData.chapter_id}
//                                   </td>
//                                   <td className="text-center">
//                                     {q.difficulty_id}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                         <button onClick={handleUpload}>Upload</button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//               {showVariantModal && (
//                 <div
//                   style={{
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: "rgba(0,0,0,0.5)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     zIndex: 1000,
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "#fff",
//                       padding: "20px",
//                       width: "90%",
//                       maxWidth: "1200px",
//                       maxHeight: "90vh",
//                       overflowY: "auto",
//                       borderRadius: "8px",
//                       position: "relative",
//                     }}
//                   >
//                     <button
//                       onClick={closeVariantModal}
//                       style={{
//                         position: "absolute",
//                         top: "10px",
//                         right: "15px",
//                         fontSize: "18px",
//                         background: "transparent",
//                         border: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       ❌
//                     </button>

//                     {subQuestionData && Array.isArray(subQuestionData) ? (
//                       <div className="bg-gray-100 p-4 rounded mb-4">
//                         <h2 className="text-lg font-semibold mb-2">Variants</h2>
//                         <div className="mt-4">
//                           <table className="min-w-full divide-y divide-gray-200 border border-gray-300 text-sm">
//                             <thead className="bg-gray-100">
//                               <tr>
//                                 <th className="px-4 py-2 text-left">ID</th>
//                                 <th className="px-4 py-2 text-left">
//                                   Question
//                                 </th>
//                                 <th className="px-4 py-2 text-left">Type</th>
//                                 <th className="px-4 py-2 text-left">Class</th>
//                                 <th className="px-4 py-2 text-left">Subject</th>
//                                 <th className="px-4 py-2 text-left">Chapter</th>

//                                 <th className="px-4 py-2 text-left">
//                                   Difficulty
//                                 </th>
//                                 <th className="px-4 py-2 text-left">Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody className="bg-white divide-y divide-gray-200">
//                               {subQuestionData.map((subQ) => (
//                                 <tr key={subQ.question_id}>
//                                   <td className="px-4 py-2">
//                                     {subQ.question_id}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     {subQ.question_text}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     {subQ.type_name}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     {subQ.class_name}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     {subQ.subject_name}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     {subQ.chapter_name}
//                                   </td>

//                                   <td className="px-4 py-2">
//                                     {subQ.difficulty_name}
//                                   </td>
//                                   <td className="px-4 py-2">
//                                     <button
//                                       onClick={() =>
//                                         alert(
//                                           `Edit SubQ ID: ${subQ.question_id}`
//                                         )
//                                       }
//                                       className="text-blue-600 hover:underline text-sm"
//                                     >
//                                       Edit
//                                     </button>
//                                     {" | "}
//                                     <button
//                                       onClick={() =>
//                                         alert(
//                                           `Delete SubQ ID: ${subQ.question_id}`
//                                         )
//                                       }
//                                       className="text-red-600 hover:underline text-sm"
//                                     >
//                                       Delete
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     ) : (
//                       <p className="text-red-500 font-semibold">
//                         ❗ Sub-question not found.
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               )}
//               {showMatchModal && selectedMatchData && (
//                 <div
//                   style={{
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: "rgba(0,0,0,0.5)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     zIndex: 1000,
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "#fff",
//                       padding: "20px",
//                       width: "90%",
//                       maxWidth: "1200px",
//                       maxHeight: "90vh",
//                       overflowY: "auto",
//                       borderRadius: "8px",
//                       position: "relative",
//                     }}
//                   >
//                     <button
//                       onClick={() => setShowMatchModal(false)}
//                       style={{
//                         position: "absolute",
//                         top: "10px",
//                         right: "15px",
//                         fontSize: "18px",
//                         background: "transparent",
//                         border: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       ❌
//                     </button>

//                     {selectedMatchData &&
//                     Array.isArray(selectedMatchData.matching_options) ? (
//                       <>
//                         <h2 className="text-xl font-semibold mb-4 text-gray-800">
//                           {selectedMatchData.question_text}
//                         </h2>

//                         <table className="table-auto  border border-gray-300 rounded-md mb-4">
//                           <thead className="bg-gray-100">
//                             <tr>
//                               <th className="p-3 border-r text-center font-semibold">
//                                 Column A
//                               </th>
//                               <th className="p-3 text-center font-semibold">
//                                 Column B
//                               </th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {selectedMatchData.matching_options.map((pair) => (
//                               <tr key={pair.matching_id} className="border-t">
//                                 <td className="p-3 border-r text-gray-800">
//                                   {pair.column1_text}
//                                 </td>
//                                 <td className="p-3 text-gray-800">
//                                   {pair.column2_text}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </>
//                     ) : (
//                       <p className="text-red-500 font-semibold">
//                         ❗ Matching data not available.
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {questions.map((q, index) => (
//                 <div
//                   key={q.question_id}
//                   className=" p-3  questions-lytout m-1 rounded-2 border border-gray-200"
//                 >
//                   <h6 className="text-lg font-semibold text-gray-800 mb-2">
//                     Type: {q.type_name}
//                   </h6>
//                   {q.group_stat === "parent" && q.passage_text && (
//                     <>
//                       <p className="font-bold">Passage:</p>
//                       <p className="text-gray-700 mb-3 ml-4 italic">
//                         {q.passage_text}
//                       </p>
//                     </>
//                   )}
//                   <p className="text-gray-700 mb-3">
//                     <b>
//                       <i>Question</i>: {q.question_text}
//                     </b>
//                   </p>

//                   {q.options &&
//                     q.options.length > 0 && ( // Changed from question_details to options
//                       <ul className="list-disc w-100 ml-6 text-sm text-gray-600 ">
//                         {q.options.map((opt, optIndex) => (
//                           <li
//                             className="w-100 text-wrap"
//                             key={opt.detail_id || optIndex}
//                           >
//                             {opt.text}{" "}
//                             {opt.is_correct ? "(Correct Answer)" : ""}{" "}
//                           </li>
//                         ))}
//                       </ul>
//                     )}

//                   {q.subQuestions &&
//                     q.subQuestions.length > 0 && ( // Changed from sub_questions to subQuestions
//                       <>
//                         <p className="font-bold">Sub-questions:</p>
//                         {q.subQuestions.map((subQ, subIndex) => (
//                           <div
//                             key={subQ.question_id || subIndex}
//                             className="ml-4 mb-2 p-2 border-l-2 border-gray-300"
//                           >
//                             <p className="text-gray-700">
//                               Q.{subIndex + 1} ({subQ.type_name}):{" "}
//                               {subQ.question_text}
//                             </p>
//                             {subQ.options &&
//                               subQ.options.length > 0 && ( // Changed from question_details to options
//                                 <ul className="list-disc w-100 ml-6 text-sm text-gray-600">
//                                   {subQ.options.map((opt, optIndex) => (
//                                     <li
//                                       className="w-100"
//                                       key={opt.detail_id || optIndex}
//                                     >
//                                       {opt.text}{" "}
//                                       {opt.is_correct ? "(Correct Answer)" : ""}
//                                     </li>
//                                   ))}
//                                 </ul>
//                               )}
//                           </div>
//                         ))}
//                       </>
//                     )}

//                   <div className="text-sm text-gray w-100 ">
//                     {q.class_name && `Class: ${q.class_name}`}
//                     {q.subject_name && ` | Subject: ${q.subject_name}`}
//                     {q.chapter_name && ` | Chapter: ${q.chapter_name}`}
//                     {q.marks && ` | Marks: ${q.marks}`}
//                     {q.difficulty_name && ` | Difficulty: ${q.difficulty_name}`}
//                   </div>
//                   <div className="flex items-center space-x-2">
//                     <div className="absolute right-0 top-0 mt-2 mr-2 flex btns-section space-x-2">
//                       <button
//                         onClick={() => handleDeleteQuestion(q.question_id)}
//                         disabled={isLoading}
//                         className="bg-red-500 btn btn-outline-danger   hover:bg-red-600 transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
//                       >
//                         Delete
//                       </button>
//                       <button
//                         onClick={() => handleEditQuestion(q)}
//                         disabled={isLoading}
//                         className="   btn btn-outline-primary    transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
//                       >
//                         Edit
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}

//               <nav aria-label="Page navigation example ">
//                 <ul className="pagination justify-content-center mt-4">
//                   <li className="page-item disabled">
//                     <a
//                       className="page-link"
//                       href="#"
//                       tabindex="-1"
//                       aria-disabled="true"
//                     >
//                       <i className="bi bi-chevron-double-left"></i>
//                     </a>
//                   </li>
//                   <li className="page-item disabled">
//                     <a
//                       className="page-link"
//                       href="#"
//                       tabindex="-1"
//                       aria-disabled="true"
//                     >
//                       <i className="bi bi-chevron-left"></i>
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       1
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       2
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       3
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       4
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       5
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       6
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       <i className="bi bi-chevron-right"></i>
//                     </a>
//                   </li>
//                   <li className="page-item">
//                     <a className="page-link" href="#">
//                       <i className="bi bi-chevron-double-right"></i>
//                     </a>
//                   </li>
//                 </ul>
//               </nav>
//             </div> */}
//           </div>
//         )}
//         {addNewQuestion && (
//           <div className="mt-4">
//             <AddQuestionForm />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default QuestionBank;

import React, { useState, useEffect } from "react";
import AddQuestionForm from "./AddNewQuestion";
import { useNavigate } from "react-router-dom";
import QuestionUpload from "./QuestionUpload";
import { bulkUpload, upload } from "./config";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchQuestionTypes,
  fetchQuestionVariantsThunk,
  editVariantThunk,
  fetchQuestionsThunk,
} from "./redux/questionBankThunk";

import {
  setSelectedQuestionTypeId,
  clearSubQuestionVariants,
  setVariantEditingQuestion,
  clearVariantEditingQuestion,
  setEditingQuestion,
} from "./redux/questionBankSlice";

import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
  fetchChaptersThunk,
} from "./redux/chapterThunk";
import {
  setSelectedClassId,
  setSelectedSubjectId,
  setSelectedChapterId,
  setSubjects,
} from "./redux/chapterSlice";
import {
  apiKeyHeader,
  apiKeyHeaderMultiPartFormData,
} from "../../configs/ApiKeys";
import Select from "react-select";
import userStore from "../../zustand/userStore";
const QuestionBank = () => {
  const dispatch = useDispatch();
  const {
    questionTypes,
    selectedQuestionTypeId,
    loadingQuestionTypes,
    errorQuestionTypes,
  } = useSelector((state) => state.questionBank);

  const {
    classes,
    subjects,
    chapters,
    selectedClassId,
    selectedSubjectId,
    selectedChapterId,
    loadingClasses,
    loadingSubjects,
    loadingChapters,
    loader,
  } = useSelector((state) => state.chapter);

  //const [selectedChapterId, setSelectedChapterId] = useState("");
  // const { user } = useSelector((store) => store.authSlice);
  // // const user_id = user.user.id;
  // const user_id = user?.user?.user_id;
  const userData = userStore((state) => state.user);
  const user_id = userData?.id;
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [isProcessingAction, setIsProcessingAction] = useState(false); // For Add/Upload/Delete operations
  const [isEditing, setIsEditing] = useState(false);
  const [addVariantModal, setaddVariantModal] = useState(false);
  const [showVariantModal, setShowVariantModal] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);

  //For variant
  const [editVariantModal, setEditVariantModal] = useState(false);
  const [questionText, setQuestionText] = useState("");
  const [difficultyLevel, setDifficultyLevel] = useState("");
  const [questionType, setQuestionType] = useState("");
  const editVariantData = useSelector(
    (state) => state.questionBank.variantEditingQuestion
  );
  // Error states (centralized for better management)
  const [error, setError] = useState(null);

  //For matching
  const [selectedMatchData, setSelectedMatchData] = useState(null);
  const [showMatchModal, setShowMatchModal] = useState(false);

  const navigate = useNavigate();
  const userStr = localStorage.getItem("user");
  const userId = userStr ? JSON.parse(userStr).id : null;

  const questionTypeMapping = {
    "fill in the blanks": 15,
    "one word answer": 8,
    "answer in brief": 10,
    "definition of terms": 9,
    "difference between": 11,
    "multiple choice": 1,
    "true/false": 3,
    "short answer": 4,
    "long answer": 5,
    "draw diagram": 12,
    "label diagram": 13,
    "writing section": 14,
    "match the following": 16,
    "activity based questions": 17,
  };

  // --- Data Fetching Effects (Ordered by Dependency) ---

  useEffect(() => {
    dispatch(fetchClassesThunk());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchQuestionTypes());
  }, [dispatch]);

  //if exist in local it will store
  useEffect(() => {
    const savedId = localStorage.getItem("selectedChapterId");
    if (savedId) {
      dispatch(setSelectedChapterId(savedId));
    }
  }, []);

  const questions = useSelector((state) => state.questionBank.questions);
  const loading = useSelector((state) => state.questionBank.loading);
  // 5. Fetch Questions when all main filters are selected (including question type)
  // useEffect(() => {
  //   if (selectedClassId && selectedSubjectId && selectedChapterId) {
  //     dispatch(
  //       fetchQuestionsThunk({
  //         classId: selectedClassId,
  //         subjectId: selectedSubjectId,
  //         chapterId: selectedChapterId,
  //         questionTypeId: selectedQuestionTypeId,
  //         created_by: user_id,
  //       })
  //     );
  //   }
  //   setError(null);
  // }, [
  //   selectedClassId,
  //   selectedSubjectId,
  //   selectedChapterId,
  //   selectedQuestionTypeId,
  //   dispatch,
  // ]); // Add selectedQuestionTypeId to dependency array

  //To fetch variants of particular questions
  const subQuestionData = useSelector(
    (state) => state.questionBank.subQuestionVariants
  );

  const variantLoading = useSelector(
    (state) => state.questionBank.variantLoading
  );
  const variantError = useSelector((state) => state.questionBank.variantError);
  const handleViewClick = (question) => {
    dispatch(
      fetchQuestionVariantsThunk({
        classId: selectedClassId,
        subjectId: selectedSubjectId,
        chapterId: selectedChapterId,
        parentQuestionId: question.question_id,
      })
    );

    setShowVariantModal(true);
  };

  const handleEditVariantModal = (subQ) => {
    dispatch(setVariantEditingQuestion(subQ));
    setQuestionText(subQ.question_text);
    setDifficultyLevel(subQ.difficulty_name);
    setQuestionType(subQ.type_name); // just for display (not editable)
    setShowVariantModal(false);
    setEditVariantModal(true);
  };

  const handleEditVariantSubmit = async (e) => {
    e.preventDefault();

    const parentQuestion = subQuestionData; // Full parent question from Redux
    const variant = editVariantData; // Sub-question selected for edit

    if (!parentQuestion || !variant) return;

    // Update the sub-question inside the parent
    const updatedSubQuestions = parentQuestion.subQuestions.map((subQ) =>
      subQ.question_id === variant.question_id
        ? {
            ...subQ,
            question_text: questionText.trim(),
          }
        : subQ
    );
    console.log("sub before", updatedSubQuestions);

    const payload = {
      ...parentQuestion, // contains existing created_by, updated_by
      subQuestions: updatedSubQuestions,
    };

    try {
      const resultAction = await dispatch(
        editVariantThunk({
          questionPayload: payload,
          userId: localStorage.getItem("user_id"),
        })
      );

      if (editVariantThunk.fulfilled.match(resultAction)) {
        dispatch(clearVariantEditingQuestion());
        setEditVariantModal(false);
        alert("✅ Variant updated successfully.");
      } else {
        alert("❌ Failed to update variant: " + resultAction.payload);
      }
    } catch (error) {
      console.error("Variant update error:", error);
      alert("❌ Unexpected error occurred.");
    }
  };

  const handleDeleteVariant = async (variantId) => {
    if (!variantId) return;

    try {
      const response = await axios.delete(`${questions}/${variantId}`);

      console.log("Variant deleted successfully:", response.data);

      // Optional: Refresh the variants list
      dispatch(
        fetchQuestionVariantsThunk({
          classId: selectedClassId,
          subjectId: selectedSubjectId,
          chapterId: selectedChapterId,
          parentQuestionId: subQuestionData.question_id,
        })
      );

      alert("Variant deleted successfully.");
    } catch (error) {
      console.error("Delete failed:", error);
      alert(
        `Failed to delete variant: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const closeVariantModal = () => {
    dispatch(clearSubQuestionVariants());
    setShowVariantModal(false);
  };

  //To upload data to server for variant
  const handleUpload = async () => {
    const userStr = localStorage.getItem("user");
    const userId = userStr ? JSON.parse(userStr).id : null;

    if (!userId || !uploadedData || !uploadedData.questions?.length) {
      setError("Missing user ID or uploaded questions.");
      return;
    }

    if (!selectedClassId || !selectedSubjectId || !selectedChapterId) {
      setError("Please select a Class, Subject, and Chapter before uploading.");
      return;
    }
    console.log("Uploaded Data ", uploadedData);
    const questionsToUpload = uploadedData.questions.map((q) => ({
      ...q,
      question_typeid:
        questionTypeMapping[q.question_type?.toLowerCase()?.trim()] ||
        q.question_typeid ||
        null,
      link_id: parseInt(selectedQuestionId, 10),
      class_id: parseInt(selectedClassId, 10),
      subject_id: parseInt(selectedSubjectId, 10),
      chapter_id: parseInt(selectedChapterId, 10),
      created_by: userId,
      options: q.options || [], // ensure empty array if not present
      images: q.images || [],
      matching_options: q.matching_options || [],
      subQuestions: q.subQuestions || [],
    }));

    console.log("question to upload", questionsToUpload);

    const payload = {
      created_by: userId,
      class_id: parseInt(selectedClassId, 10),
      subject_id: parseInt(selectedSubjectId, 10),
      chapter_id: parseInt(selectedChapterId, 10),
      questions: questionsToUpload,
    };

    try {
      const response = await axios.post(bulkUpload, payload, {
        headers: apiKeyHeaderMultiPartFormData(), // Headers
      });
      console.log("Upload success:", response.data);

      setUploadedData(null);
      closeAddVariantModal(); // Use closeModal to reset states properly
      setError("Questions uploaded successfully."); // Display success message
    } catch (error) {
      console.error("Upload failed:", error);
      setError(
        `Failed to upload questions: ${
          error.message || "An error occurred during upload."
        }`
      );
    }
  };

  const handleAddQuestionsFromFile = async (fileQuestions) => {
    if (!selectedClassId || !selectedSubjectId || !selectedChapterId) {
      alert(
        "Please select a Class, Subject, and Chapter before uploading questions."
      );
      setError(
        "Please select a Class, Subject, and Chapter to upload questions."
      );
      return;
    }

    const classIdInt = parseInt(selectedClassId, 10);
    const subjectIdInt = parseInt(selectedSubjectId, 10);
    const chapterIdInt = parseInt(selectedChapterId, 10);

    if (isNaN(classIdInt) || isNaN(subjectIdInt) || isNaN(chapterIdInt)) {
      alert(
        "Invalid Class, Subject, or Chapter ID selected for file upload. Please re-select from the dropdowns."
      );
      setError(
        "One or more selected IDs are invalid for file upload. Please check your selections."
      );
      return;
    }

    setIsProcessingAction(true);
    setError(null);
    try {
      const questionsWithCategory = fileQuestions.map((q) => ({
        ...q,
        class_id: classIdInt,
        subject_id: subjectIdInt,
        chapter_id: chapterIdInt,
      }));

      console.log(
        "Sending bulk upload payload from QuestionBank:",
        questionsWithCategory
      );

      const response = await fetch(bulkUpload, {
        method: "POST",
        headers: apiKeyHeader(),
        body: JSON.stringify(questionsWithCategory),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! Status: ${response.status}`
        );
      }

      const result = await response.json();
      alert(`Questions from file added successfully! ${result.message || ""}`);
      const queryParams = new URLSearchParams();
      queryParams.append("class_id", selectedClassId);
      queryParams.append("subject_id", selectedSubjectId);
      queryParams.append("chapter_id", selectedChapterId);
      if (selectedQuestionTypeId) {
        // Include question type in refetch
        queryParams.append("questionType", selectedQuestionTypeId);
      }
      dispatch(
        fetchQuestionsThunk({
          classId: selectedClassId,
          subjectId: selectedSubjectId,
          chapterId: selectedChapterId,
          questionTypeId: selectedQuestionTypeId,
          created_by: user_id,
        })
      );
    } catch (err) {
      console.error("Error adding questions from file:", err);
      setError(`Failed to add questions from file: ${err.message}`);
      alert(`Failed to add questions from file: ${err.message}`);
    } finally {
      setIsProcessingAction(false);
    }
  };
  const handleEditQuestion = async (question) => {
    dispatch(setEditingQuestion(question));
  };

  const handleDeleteQuestion = async (id) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this question? This action cannot be undone."
      )
    ) {
      return;
    }
    setIsProcessingAction(true);
    setError(null);
    try {
      const response = await fetch(`${questions}/${id}`, {
        method: "DELETE",
        headers: apiKeyHeader(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! Status: ${response.status}`
        );
      }

      alert("Question deleted successfully!");
      const queryParams = new URLSearchParams();
      queryParams.append("class_id", selectedClassId);
      queryParams.append("subject_id", selectedSubjectId);
      queryParams.append("chapter_id", selectedChapterId);
      if (selectedQuestionTypeId) {
        // Include question type in refetch
        queryParams.append("questionType", selectedQuestionTypeId);
      }
      dispatch(
        fetchQuestionsThunk({
          classId: selectedClassId,
          subjectId: selectedSubjectId,
          chapterId: selectedChapterId,
          questionTypeId: selectedQuestionTypeId,
          created_by: user_id,
        })
      );
    } catch (err) {
      console.error("Error deleting question:", err);
      setError(`Failed to delete question: ${err.message}`);
      alert(`Failed to delete question: ${err.message}`);
    } finally {
      setIsProcessingAction(false);
    }
  };

  console.log("question", questions);
  // UI reordering only; does not persist changes to backend
  // const moveQuestion = (index, direction) => {
  //   setQuestions((prev) => {
  //     const newQuestions = [...prev];
  //     const targetIndex = direction === "up" ? index - 1 : index + 1;
  //     if (targetIndex < 0 || targetIndex >= newQuestions.length) return prev;
  //     [newQuestions[index], newQuestions[targetIndex]] = [
  //       newQuestions[targetIndex],
  //       newQuestions[index],
  //     ];
  //     return newQuestions;
  //   });
  // };

  const goToAnswerPage = () => {
    navigate("/answer-questions");
  };

  const goToTestPage = () => {
    navigate("/answer-questions");
  };

  // Check if all necessary category filters are selected (excluding question type, which is optional)
  const selectedCategoryValid =
    selectedClassId && selectedSubjectId && selectedChapterId;

  // Determine if any loading or processing is happening
  const isLoading =
    loadingClasses ||
    loadingSubjects ||
    loadingChapters ||
    loadingQuestionTypes ||
    loadingQuestions ||
    isProcessingAction; // Include new loading state

  const handleParsedData = (data) => {
    console.log("data");
  };
  const handleAddClick = (id) => {
    setSelectedQuestionId(id);
    setaddVariantModal(true);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        upload,
        { headers: apiKeyHeaderMultiPartFormData() },
        formData
      );
      let data = response.data;

      // Assign unique client-side IDs if not already present
      if (data && Array.isArray(data.questions)) {
        data.questions = data.questions.map((q) => ({
          ...q,
          id: q.id || uuidv4(), // Use existing ID or generate a new one
        }));
      }

      setUploadedData(data);
      localStorage.setItem("uploadedQuestions", JSON.stringify(data));
      setIsEditing(false); // Ensure edit mode is off after new upload
      dispatch(setEditingQuestion(null));
    } catch (error) {
      console.error("File upload failed:", error);
      // Optionally, show an error message to the user
    }
  };

  const closeAddVariantModal = () => {
    setaddVariantModal(false);
    setSelectedQuestionId(null);
  };

  // console.log("Uploading for question ID:", selectedQuestionId);
  // console.log("Selected file:", file.name);

  const filteredQuestions = questions;
  // .filter((q) => {
  //   if (selectedQuestionTypeId === "") return true;
  //   const selectedType = questionTypes.find(
  //     (type) => type.type_id.toString() === selectedQuestionTypeId
  //   );
  //   return q.type_name === selectedType?.type_name;
  // });
  // const container_bg = {
  //   backgroundImage: "url(/images/schoold-home-banner.PNG)",
  //   backgroundSize: "30%",
  //   minHeight: "100vh",
  //   backgroundPosition: "bottom right",
  //   backgroundRepeat: "no-repeat",
  //   margin: "-1rem -3rem",
  //   // background:'rgba(255, 255, 255, 0.8)'
  // };

  //
  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target?.value || "";
    console.log("value", value);

    // dispatch(setFormData({ name, value }));

    if (name === "class" && value) {
      dispatch(setSelectedClassId(value));
      dispatch(fetchSubjectsByClassThunk(value));
    }

    if (name === "subject" && value) {
      dispatch(setSelectedSubjectId(value));
      dispatch(
        fetchChaptersThunk({
          subjectId: value,
          classId: selectedClassId,
        })
      );
    }

    if (name === "chapter" && value) {
      dispatch(setSelectedChapterId(value));
    }
    if (name === "questionType" && value) {
      dispatch(setSelectedQuestionTypeId(value));
      dispatch(
        fetchQuestionsThunk({
          classId: selectedClassId,
          subjectId: selectedSubjectId,
          chapterId: selectedChapterId,
          questionTypeId: value,
          created_by: user_id,
        })
      );
    }

    // if (
    //   name === "schoolName" ||
    //   name === "examName" ||
    //   name === "maxMarks" ||
    //   name === "termsText" ||
    //   name === "displayTerms" ||
    //   name === "displayHeader"
    // ) {
    //   const { subjectName, className } = findById(formData, subjects, classes);
    //   const updatedFormData = {
    //     ...formData,
    //     subjectName,
    //     className,
    //     [name]: value,
    //   };
    //   dispatch(updateCategories(getHeaderData(updatedFormData).categoryData));
    // }
  };

  const optionsQTypes = questionTypes.map((type) => ({
    value: type.type_id.toString(),
    label: type.type_name,
  }));
  function getQuestionType(id) {
    return optionsQTypes.find((e) => e.value === String(id))?.label || "";
  }
  return (
    <div
      className=" container_bg container-fluid w-100 mx-auto font-inter"
    
    >
      <div className="row mx-auto w-100 px-5 py-3 mx-5">
        <div className="col-md-12 w-100">
          {/* <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Question Bank
          </h3> */}

          {/* Error Display Section */}
          {error && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-2 max-w-3xl mx-auto"
              role="alert"
            >
              <span className="block sm:inline"> {error}</span>
            </div>
          )}
          {/* Filters + Form block */}
          <div className="bg-white  mb-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 py-4 ps-3 shadow rounded-3  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
              {/* Filter 1: Class */}
              <div className="row w-100 p-3">
                <div className="col-md-6 px-2">
                  <div className="row mb-2">
                    <label
                      htmlFor="class-select"
                      className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
                    >
                      Select Class:
                    </label>
                    <div className="col-sm-8">
                      <Select
                        options={classes}
                        required
                        value={
                          classes.find(
                            (opt) => opt.value === selectedClassId
                          ) || null
                        }
                        onChange={(e) => {
                          const name = "class";
                          const value = e.value;
                          handleOnChange({ target: { name, value } });
                        }}
                        isDisabled={loader}
                        placeholder="Select Class"
                        className="custom-select-wrapper custom-select"
                        classNamePrefix="custom-select"
                      />
                    </div>
                  </div>
                </div>

                {/* Filter 2: Subject */}
                <div className="col-md-6 px-2">
                  <div className="row mb-2">
                    <label
                      htmlFor="subject-select"
                      className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
                    >
                      Select Subject:
                    </label>
                    <div className="col-sm-8">
                      <Select
                        options={subjects}
                        required
                        value={
                          subjects.find(
                            (opt) => opt.value === selectedSubjectId
                          ) || null
                        }
                        onChange={(e) => {
                          const name = "subject";
                          const value = e.value;
                          handleOnChange({ target: { name, value } });
                        }}
                        isDisabled={loader}
                        placeholder="Select Subject"
                        className="custom-select-wrapper custom-select "
                        classNamePrefix="custom-select"
                      />
                    </div>
                  </div>
                </div>

                {/* Filter 3: Chapter */}
                <div className="col-md-6 px-2">
                  <div className="row mb-2">
                    <label
                      htmlFor="chapter-select"
                      className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
                    >
                      Select Chapter:
                    </label>
                    <div className="col-sm-8">
                      <Select
                        options={chapters}
                        required
                        value={
                          chapters.find(
                            (opt) => opt.value === selectedChapterId
                          ) || null
                        }
                        onChange={(e) => {
                          const name = "chapter";
                          const value = e.value;
                          handleOnChange({ target: { name, value } });
                        }}
                        isDisabled={loader}
                        placeholder="Select Chapter"
                        className="custom-select-wrapper custom-select "
                        classNamePrefix="custom-select"
                      />
                      {/* <select
                        id="chapter-select"
                        value={selectedChapterId}
                        onChange={(e) => {
                          const value = e.target.value; // ✅ define value
                          dispatch(setSelectedChapterId(value));
                          localStorage.setItem("selectedChapterId", value);
                        }}
                        className="w-full p-2 form-control border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        disabled={
                          !selectedSubjectId ||
                          !selectedClassId ||
                          loadingChapters ||
                          chapters.length === 0
                        }
                      >
                        <option value="">-- Select Chapter --</option>
                        {loadingChapters ? (
                          <option disabled>Loading chapters...</option>
                        ) : chapters.length === 0 &&
                          selectedSubjectId &&
                          selectedClassId ? (
                          <option disabled>No chapters for this subject</option>
                        ) : (
                          chapters.map((chap) => (
                            <option
                              key={chap.chapter_id}
                              value={chap.chapter_id.toString()}
                            >
                              {chap.chapter_name}
                            </option>
                          ))
                        )}
                      </select> */}
                    </div>
                  </div>
                </div>

                {/* Filter 4: Question Type */}
                <div className="col-md-6 px-2">
                  <div className="row mb-2">
                    <label
                      htmlFor="question-type-select"
                      className="block text-sm col-sm-4 col-form-label font-medium text-gray-700 mb-1"
                    >
                      Select Question Type:
                    </label>
                    <div className="col-sm-8">
                      <Select
                        options={optionsQTypes}
                        value={
                          optionsQTypes.find(
                            (opt) => opt.value === selectedQuestionTypeId
                          ) || null
                        }
                        onChange={(selected) => {
                          const name = "questionType";
                          const value = selected ? selected.value : ""; // if cleared, set to ""
                          handleOnChange({ target: { name, value } });
                          setSelectedQuestionTypeId(value); // update local state or Redux
                        }}
                        placeholder="Select Question Type"
                      />

                      {/* <select
                        id="question-type-select"
                        value={selectedQuestionTypeId}
                        onChange={(e) => {
                          dispatch(setSelectedQuestionTypeId(e.target.value));
                          localStorage.setItem(
                            "selectedQuestionTypeId",
                            e.target.value
                          );
                        }}
                        className="w-full form-control p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        disabled={
                          // loadingQuestionTypes ||
                          // questionTypes.length === 0 ||
                          // isLoading
                          !selectedClassId ||
                          !selectedSubjectId ||
                          !selectedChapterId
                        }
                      >
                        <option value="">-- All Types --</option>
                        {loadingQuestionTypes ? (
                          <option disabled>Loading types...</option>
                        ) : questionTypes.length === 0 ? (
                          <option disabled>No types available</option>
                        ) : (
                          questionTypes.map((type) => (
                            <option
                              key={type.type_id}
                              value={type.type_id.toString()}
                            >
                              {type.type_name}
                            </option>
                          ))
                        )}
                      </select> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* Validation Message */}
              {!selectedCategoryValid && (
                <p className="text-center text-red-600 mb-2">
                  Please select a <strong>Class</strong>,{" "}
                  <strong>Subject</strong>, and <strong>Chapter</strong> to add
                  or view questions.
                </p>
              )}
              {classes.length === 0 && !loadingClasses && (
                <p className="text-center text-gray-600 mb-2">
                  No classes available. Please add classes first.
                </p>
              )}

              {/* Add Question Form neatly centered below */}
              <div className="row w-100">
                <div className="col-md-12 pe-2">
                  {false && <QuestionUpload onDataParsed={handleParsedData} />}
                  <AddQuestionForm />
                </div>
              </div>
            </div>
          </div>

          {/* <QuestionPopup onSubmit={handleAddQuestion} questionTypes={questionTypes} /> */}

          {/* Action Buttons */}
          {/* <div className="mt-6 flex justify-center space-x-4">
                <button
                    onClick={goToAnswerPage}
                    disabled={questions.length === 0 || isLoading}
                    className="bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition duration-300 ease-in-out shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Answer Questions
                </button>
                <button
                    onClick={goToTestPage}
                    disabled={questions.length === 0 || isLoading}
                    className="bg-purple-600 text-white px-6 py-3 rounded-md hover:bg-purple-700 transition duration-300 ease-in-out shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Go to Test Page
                </button>
            </div> */}

          <hr className="my-8 border-gray-300" />

          {/* Questions List */}
          {loadingQuestions ? (
            <p className="text-center text-gray-600">Loading questions...</p>
          ) : questions.length === 0 &&
            selectedCategoryValid &&
            !loadingQuestions ? (
            <p className="text-center text-gray-600">
              No questions available for the selected category/type. Add a
              question to get started.
            </p>
          ) : (
            <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
              <div className="table-responsive p-2 rounded-3">
                <table className="table  table-striped table-bordered text-15">
                  <tbody>
                    <tr className="bg-gray-200 text-gray-700">
                      <th className="text-center">ID</th>
                      <th className="text-center">Question </th>
                      <th className="text-center">Type</th>
                      <th className="text-center">Class</th>
                      <th className="text-center">Subject</th>
                      <th className="text-center">Chapter</th>
                      <th className="text-center">Upload</th>
                      <th className="text-center">Difficulty</th>
                      <th className="text-center" style={{ minWidth: "110px" }}>
                        Actions
                      </th>
                    </tr>
                    {filteredQuestions.map((q) => (
                      <tr key={q.question_id} className="hover:bg-gray-100">
                        <td className="text-center">
                          <span key={q.question_id}> {q.question_id}</span>
                        </td>
                        <td className="text-wrap">
                          {q.question_typeid === 6
                            ? q.passage_text
                            : q.question_text}
                        </td>
                        {/* <td className="text-center">{q.type_name}</td> */}
                        <td className="text-center">
                          {getQuestionType(q.question_typeid)}
                        </td>
                        <td className="text-center">{q.class_name}</td>
                        <td className="text-center">{q.subject_name}</td>
                        <td className="text-center">{q.chapter_name}</td>
                        <td className="text-center">
                          {q.question_typeid === 16 ? ( //16 is for matching
                            <button
                              onClick={() => {
                                setSelectedMatchData(q); // q is the full question object
                                setShowMatchModal(true);
                              }}
                            >
                              View More
                            </button>
                          ) : (
                            <>
                              <button
                                style={{
                                  margin: "0",
                                  backgroundColor: "#0d6efd", // blue if enabled, gray if disabled
                                  color: "#fff",
                                  border: "none",
                                  padding: "0.375rem 0.75rem",
                                  borderRadius: "0.25rem",
                                  cursor: "pointer",
                                  marginRight: "1%",
                                  opacity: 1,
                                }}
                                onClick={() => handleAddClick(q.question_id)}
                              >
                                Add
                              </button>
                              <button
                                style={{
                                  margin: "0",
                                  backgroundColor: "#0d6efd", // blue if enabled, gray if disabled
                                  color: "#fff",
                                  border: "none",
                                  padding: "0.375rem 0.75rem",
                                  borderRadius: "0.25rem",
                                  cursor: "pointer",

                                  opacity: 1,
                                }}
                                onClick={() => handleViewClick(q)}
                              >
                                View
                              </button>
                            </>
                          )}
                        </td>

                        <td className="text-center">{q.difficulty_name}</td>
                        <td className="text-center">
                          <div className="flex justify-center space-x-2">
                            <button
                              onClick={() =>
                                handleDeleteQuestion(q.question_id)
                              }
                              disabled={isLoading}
                              className="bg-red-500 btn btn-sm btn-outline-danger   hover:bg-red-600 transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                            <button
                              onClick={() => handleEditQuestion(q)}
                              disabled={isLoading}
                              style={{ marginLeft: "2%" }}
                              className="   btn btn-sm btn-outline-primary    transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div>
                {addVariantModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: "20px",
                        width: "90%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "8px",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={() => closeAddVariantModal()}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          fontSize: "18px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        ❌
                      </button>
                      <h2>Upload Question File</h2>
                      <input
                        type="file"
                        accept=".json,.xlsx"
                        onChange={handleFileUpload}
                      />

                      {uploadedData?.questions?.length > 0 && (
                        <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative mt-4">
                          <div className="table-responsive p-2 rounded-3">
                            <table className="table table-striped table-bordered text-15 w-full">
                              <thead>
                                <tr className="bg-gray-200 text-gray-700">
                                  <th className="text-center">#</th>
                                  <th className="text-center">Question</th>
                                  <th className="text-center">Options</th>
                                  <th className="text-center">Type ID</th>
                                  <th className="text-center">Class ID</th>
                                  <th className="text-center">Subject ID</th>
                                  <th className="text-center">Chapter ID</th>
                                  <th className="text-center">Difficulty ID</th>
                                </tr>
                              </thead>
                              <tbody>
                                {uploadedData.questions.map((q, index) => (
                                  <tr
                                    key={q.id || index}
                                    className="hover:bg-gray-100"
                                  >
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-wrap">
                                      {q.question_text}
                                    </td>
                                    <td className="text-wrap max-w-xs min-w-[150px] break-words">
                                      <ol
                                        type="A"
                                        className="pl-4 list-decimal"
                                      >
                                        {Array.isArray(q.options) &&
                                          q.options.map((opt, i) => (
                                            <li key={i}>{opt.text}</li>
                                          ))}
                                      </ol>
                                    </td>
                                    <td className="text-center">
                                      {q.question_typeid}
                                    </td>
                                    <td className="text-center">
                                      {uploadedData.class_id}
                                    </td>
                                    <td className="text-center">
                                      {uploadedData.subject_id}
                                    </td>
                                    <td className="text-center">
                                      {uploadedData.chapter_id}
                                    </td>
                                    <td className="text-center">
                                      {q.difficulty_id}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <button onClick={handleUpload}>Upload</button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {editVariantModal && editVariantData && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: "20px",
                        width: "35%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "8px",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={() => {
                          dispatch(clearVariantEditingQuestion());
                          setEditVariantModal(false);
                        }}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          fontSize: "18px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        ❌
                      </button>
                      <div className="p-4 bg-white rounded shadow-lg w-full max-w-xl mx-auto">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">
                          Edit Variant Question
                        </h2>

                        <form
                          onSubmit={handleEditVariantSubmit}
                          className="space-y-6"
                        >
                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label text-end">
                              Question Type
                            </label>
                            <div className="col-sm-9">
                              <select className="form-control" disabled>
                                <option>{questionType}</option>
                              </select>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label text-end">
                              Difficulty Level
                            </label>
                            <div className="col-sm-9">
                              <select className="form-control" disabled>
                                <option>{difficultyLevel}</option>
                              </select>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label text-end">
                              Question Text
                            </label>
                            <div className="col-sm-9">
                              <textarea
                                className="form-control"
                                rows="2"
                                value={questionText}
                                onChange={(e) =>
                                  setQuestionText(e.target.value)
                                }
                                placeholder="Enter updated question text"
                              />
                            </div>
                          </div>

                          <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => setEditVariantModal(false)}
                            >
                              Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Update
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}

                {showVariantModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: "20px",
                        width: "90%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "8px",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={closeVariantModal}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          fontSize: "18px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        ❌
                      </button>

                      {subQuestionData?.subQuestions &&
                      Array.isArray(subQuestionData.subQuestions) ? (
                        <div className="bg-gray-100 p-4 rounded mb-4">
                          <h2 className="text-lg font-semibold mb-2">
                            Variants
                          </h2>
                          <div className="mt-4">
                            <table className="table table-bordered table-striped table-hover text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="px-4 py-2 text-left">ID</th>
                                  <th className="px-4 py-2 text-left">
                                    Question
                                  </th>
                                  <th className="px-4 py-2 text-left">Type</th>
                                  <th className="px-4 py-2 text-left">Class</th>
                                  <th className="px-4 py-2 text-left">
                                    Subject
                                  </th>
                                  <th className="px-4 py-2 text-left">
                                    Chapter
                                  </th>
                                  <th className="px-4 py-2 text-left">
                                    Difficulty
                                  </th>
                                  <th className="px-4 py-2 text-left">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {subQuestionData.subQuestions.map((subQ) => (
                                  <tr key={subQ.question_id}>
                                    <td className="px-4 py-2">
                                      {subQ.question_id}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.question_text}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.type_name}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.class_name}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.subject_name}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.chapter_name}
                                    </td>
                                    <td className="px-4 py-2">
                                      {subQ.difficulty_name}
                                    </td>
                                    <td className="px-4 py-2">
                                      <button
                                        onClick={() =>
                                          handleEditVariantModal(subQ)
                                        }
                                        className="text-blue-600 hover:underline text-sm"
                                      >
                                        Edit
                                      </button>{" "}
                                      |{" "}
                                      <button
                                        onClick={() =>
                                          handleDeleteVariant(subQ.question_id)
                                        }
                                        className="text-red-600 hover:underline text-sm"
                                      >
                                        Delete
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : (
                        <p className="text-red-500 font-semibold">
                          ❗ Sub-questions not found. {variantError}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {showMatchModal && selectedMatchData && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: "20px",
                        width: "90%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "8px",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={() => setShowMatchModal(false)}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          fontSize: "18px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        ❌
                      </button>

                      {selectedMatchData &&
                      Array.isArray(selectedMatchData.matching_options) ? (
                        <>
                          <h2 className="text-xl font-semibold mb-4 text-gray-800">
                            {selectedMatchData.question_text}
                          </h2>

                          <table className="table table-bordered table-striped table-hover text-sm">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="p-3 border-r text-center font-semibold">
                                  Column A
                                </th>
                                <th className="p-3 text-center font-semibold">
                                  Column B
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedMatchData.matching_options.map(
                                (pair) => (
                                  <tr
                                    key={pair.matching_id}
                                    className="border-t"
                                  >
                                    <td className="p-3 border-r text-gray-800">
                                      {pair.column1_text}
                                    </td>
                                    <td className="p-3 text-gray-800">
                                      {pair.column2_text}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <p className="text-red-500 font-semibold">
                          ❗ Matching data not available.
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* {questions.map((q, index) => (
                <div
                  key={q.question_id}
                  className=" p-3  questions-lytout m-1 rounded-2 border border-gray-200"
                >
                  <h6 className="text-lg font-semibold text-gray-800 mb-2">
                    Type: {q.type_name}
                  </h6>
                  {q.group_stat === "parent" && q.passage_text && (
                    <>
                      <p className="font-bold">Passage:</p>
                      <p className="text-gray-700 mb-3 ml-4 italic">
                        {q.passage_text}
                      </p>
                    </>
                  )}
                  <p className="text-gray-700 mb-3">
                    <b>
                      <i>Question</i>: {q.question_text}
                    </b>
                  </p>

                  {q.options &&
                    q.options.length > 0 && ( // Changed from question_details to options
                      <ul className="list-disc w-100 ml-6 text-sm text-gray-600 ">
                        {q.options.map((opt, optIndex) => (
                          <li className="w-100 text-wrap" key={opt.detail_id || optIndex}>
                            {opt.text}{" "}
                            {opt.is_correct ? "(Correct Answer)" : ""}{" "}
                          
                          </li>
                        ))}
                      </ul>
                    )}

                  {q.subQuestions &&
                    q.subQuestions.length > 0 && ( // Changed from sub_questions to subQuestions
                      <>
                        <p className="font-bold">Sub-questions:</p>
                        {q.subQuestions.map((subQ, subIndex) => (
                          <div
                            key={subQ.question_id || subIndex}
                            className="ml-4 mb-2 p-2 border-l-2 border-gray-300"
                          >
                            <p className="text-gray-700">
                              Q.{subIndex + 1} ({subQ.type_name}):{" "}
                              {subQ.question_text}
                            </p>
                            {subQ.options &&
                              subQ.options.length > 0 && ( // Changed from question_details to options
                                <ul className="list-disc w-100 ml-6 text-sm text-gray-600">
                                  {subQ.options.map((opt, optIndex) => (
                                    <li className="w-100" key={opt.detail_id || optIndex}>
                                      {opt.text}{" "}
                                      {opt.is_correct ? "(Correct Answer)" : ""}
                                    </li>
                                  ))}
                                </ul>
                              )}
                          </div>
                        ))}
                      </>
                    )}

                  <div className="text-sm text-gray w-100 ">
                    {q.class_name && `Class: ${q.class_name}`}
                    {q.subject_name && ` | Subject: ${q.subject_name}`}
                    {q.chapter_name && ` | Chapter: ${q.chapter_name}`}
                    {q.marks && ` | Marks: ${q.marks}`}
                    {q.difficulty_name && ` | Difficulty: ${q.difficulty_name}`}
                  </div>
                  <div className="flex items-center space-x-2">
                    
                    <div className="absolute right-0 top-0 mt-2 mr-2 flex btns-section space-x-2">
                      <button
                        onClick={() => handleDeleteQuestion(q.question_id)}
                        disabled={isLoading}
                        className="bg-red-500 btn btn-outline-danger   hover:bg-red-600 transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Delete
                      </button>
                      <button
                        onClick={() => handleEditQuestion(q)}
                        disabled={isLoading}
                        className="   btn btn-outline-primary    transition duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                  
                </div>
              ))} */}

                <nav aria-label="Page navigation example ">
                  <ul className="pagination justify-content-center mt-4">
                    <li className="page-item disabled">
                      <a
                        className="page-link"
                        href="#"
                        tabIndex="-1"
                        aria-disabled="true"
                      >
                        <i className="bi bi-chevron-double-left"></i>
                      </a>
                    </li>
                    <li className="page-item disabled">
                      <a
                        className="page-link"
                        href="#"
                        tabIndex="-1"
                        aria-disabled="true"
                      >
                        <i className="bi bi-chevron-left"></i>
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        3
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        4
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        5
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        6
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        <i className="bi bi-chevron-right"></i>
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        <i className="bi bi-chevron-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionBank;
